<div class="alert-badge">
    <div class="alert-badge-header" (click)="toggle()">
        <span *ngIf="!loading" class="alert-badge-count">{{ count }}</span>
        <i *ngIf="loading" class="fa fa-spinner fa-spin alert-badge-spinner"></i>
        <span class="alert-badge-title">{{ title }}</span>
        <i class="fas" [ngClass]="expanded ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
    </div>

    <div *ngIf="expanded" class="alert-badge-body">
        <ng-container *ngIf="!loading; else waiting">
            <label *ngFor="let name of items" class="alert-badge-item">{{ name }}</label>
        </ng-container>
        <ng-template #waiting>
            <label>Events left on waiting ...</label>
        </ng-template>
    </div>
</div>
